export const invitesHeaders = [
  {
    text: "Name",
    value: "name",
    sortable: false,
  },
  {
    text: "Email",
    value: "email",
    sortable: false,
  },
  {
    text: "Status",
    value: "status",
  },
  {
    text: "",
    value: "actions",
    sortable: false,
  },
];

export const patientsHeaders = [
  {
    text: "Name",
    value: "name",
    sortable: false,
  },
  {
    text: "Email",
    value: "email",
    sortable: false,
  },
  {
    text: "State",
    value: "state",
  },
  {
    text: "DOB",
    value: "birthDate",
  },
  {
    text: "Current Practitioner",
    value: "practitioner",
  },
  {
    text: "",
    value: "actions",
    sortable: false,
  },
];
